import { useFlag } from '@calendly/feature-check-react';
import { useBooleanState } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useLayoutEffect, forwardRef } from 'react';
import { getInitials } from './utils';
const containerIsPhoneCss = "cg1yy3n";
const containerCss = "c4xvuk4";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const contactContainerCss = "c19zny4e";
const ContactContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contactContainerCss, props.className)} />;
});
const contactNameCss = "c1vzj9vk";
const ContactName = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(contactNameCss, props.className)} />);
const closeButtonCss = "c1r78q1x";
const CloseButton = forwardRef((props, ref) => {
  const size = 'small';
  return <IconButton ref={ref} {...props} size={size} className={classNames(closeButtonCss, props.className)}>
      <CloseIcon />
    </IconButton>;
});
export const Header = ({
  actionKind,
  contact,
  onClose
}) => {
  const isContactsShareCTAFeatureEnabled = useFlag('org_expansion_share_cta_feature');
  const [isTooltipShown, showTooltip] = useBooleanState(false);
  const isSingleUseLinkCreation = actionKind === 'single_use_link_creation';
  let headingText = I18n.t('publisher.event_types.share.share_availability');
  if (actionKind === 'book_meeting') {
    headingText = isContactsShareCTAFeatureEnabled ? I18n.t('publisher.event_types.share.book_meeting') : I18n.t('publisher.event_types.share.create_event');
  }
  if (isSingleUseLinkCreation) {
    headingText = I18n.t('publisher.event_types.share.create_single_use_link');
  }
  useLayoutEffect(() => {
    showTooltip();
  }, [showTooltip]);
  return <Container>
      <div>
        <HeadingText level="1" size="medium">
          {headingText}
        </HeadingText>
        {contact && <ContactContainer>
            <FullStoryExclude>
              <Avatar letter={getInitials(contact.name)} size="x-small" src={contact.url} tooltip={contact.name} />
            </FullStoryExclude>
            <ContactName>
              <FullStoryMask>
                {contact.name}
              </FullStoryMask>
            </ContactName>
          </ContactContainer>}
      </div>
      <CloseButton title={isTooltipShown ? I18n.t('publisher.action.close') : ''} onClick={onClose} />
    </Container>;
};

require("./header.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");